import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home_search",
  "use": "icon-home_search-usage",
  "viewBox": "0 0 28.485 28.484",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.485 28.484\" id=\"icon-home_search\"><defs><style>#icon-home_search .a{fill:#ccc;}</style></defs><path class=\"a\" d=\"M98.39,85.333a13.086,13.086,0,0,1,10.225,21.253l4.747,4.749a1.454,1.454,0,1,1-2.056,2.056l-4.749-4.747A13.086,13.086,0,1,1,98.39,85.333Zm0,2.908a10.178,10.178,0,1,0,10.178,10.178A10.178,10.178,0,0,0,98.39,88.241Z\" transform=\"translate(-85.303 -85.333)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol